/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {Company} from '../../core/_models'
import {useListView} from '../../core/ListViewProvider'

type Props = {
  company: Company
}

const CompanyInfoCell: FC<Props> = ({company}) => {
  const {setItemIdForUpdate} = useListView()
  const openEditModal = () => {
    setItemIdForUpdate(company.id)
  }

  return (
    <div className='d-flex align-items-center'>
      <div className='d-flex flex-column'>
        <a
          onClick={openEditModal}
          role='button'
          className='text-gray-800 text-hover-primary mb-1 pointer-cli'
        >
          {company.name}
        </a>
      </div>
    </div>
  )
}

export {CompanyInfoCell}
